import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './Routes';
import Page from './components/Page';
import ErrorBoundary from './components/ErrorBoundary';
import GlobalSnackbar from './components/GlobalSnackbar';
import { AuthProvider } from './auth/AuthContext';
import SiteGatePage from './SiteGatePage';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'aos/dist/aos.css';

const isGated = (): boolean => {
  const hasToken = !!localStorage.getItem('token');
  const isUnlocked = localStorage.getItem('siteUnlocked') === 'true';
  return !hasToken && !isUnlocked;
};

const App = (): JSX.Element => {
  const [gated, setGated] = useState(isGated);

  if (gated) {
    return <SiteGatePage onUnlock={() => setGated(false)} />;
  }

  return (
    <ErrorBoundary>
      <Page>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <Routes />
          </AuthProvider>
        </BrowserRouter>
      </Page>
      <GlobalSnackbar />
    </ErrorBoundary>
  );
};

export default App;
